import { useSelector } from 'react-redux';
import Notification from './notification';
import Notifications from './notifications';

function getPageForRoute(key: string) {
    const selected = {
        'notifications': <Notifications />,
        'notification': < Notification />
    }[key];

    if (selected) { return selected; }
    return <Notifications />;
}

function getKeyFromPath(path: string) {
    const contentKey = 3;
    const key = path.split('/')[contentKey];
    return key;
}

const NotificationIndex = () => {
    const page = useSelector((state: any) => state.router.location.pathname);

    return getPageForRoute(getKeyFromPath(page));
}

export default NotificationIndex;
